import React, { useState } from "react";
import { NavLink } from "react-router-dom";

export default function NavbarAside({ userData }) {
  const [collapsed, setCollapsed] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false);
  const isAdmin = userData?.isAdmin === true; // true or false

  const toggleSidebar = () => setCollapsed(!collapsed);
  const toggleReports = () => setReportsOpen(!reportsOpen);

  return (
    <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <button
        id="sidebarToggle"
        className="sidebar-toggle"
        onClick={toggleSidebar}
      >
        <i
          className={`fas ${collapsed ? "fa-angle-right" : "fa-angle-left"}`}
        ></i>
      </button>

      <div className="logo">
        <img src="/assets/images/logo.png" alt="Logo" />
      </div>

      <nav className="main-nav">
        <ul>
          <li>
            <NavLink to="/dashboard" end title="Dashboard">
              <i className="fas fa-home"></i>
              {!collapsed && <span>Dashboard</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/orders" title="Orders">
              <i className="fas fa-box"></i>
              {!collapsed && <span>Orders</span>}
            </NavLink>
          </li>

          {isAdmin && (
            <li className={`has-submenu ${reportsOpen ? "open" : ""}`}>
              <div className="nav-item" onClick={toggleReports}>
                <NavLink to="/reports" title="Reports">
                  <i className="fas fa-chart-line"></i>
                  {!collapsed && (
                    <>
                      <span>Reports</span>
                      <i
                        className={`fas fa-chevron-${
                          reportsOpen ? "up" : "down"
                        } dropdown-icon`}
                      ></i>
                    </>
                  )}
                </NavLink>
              </div>
              {!collapsed && (
                <ul className={`sub-menu ${reportsOpen ? "show" : ""}`}>
                  <li>
                    <NavLink to="/reports/profit-loss" title="Profit & Loss">
                      <i className="fas fa-file-invoice-dollar"></i>
                      <span>Profit & Loss</span>
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>
          )}
          {isAdmin && (
            <li>
              <NavLink to="/addUsers" title="Add Users">
                <i className="fas fa-user"></i>
                {!collapsed && <span>Add Users</span>}
              </NavLink>
            </li>
          )}
          {isAdmin && (
            <li>
              <NavLink to="/menu" title="Menu">
                <i className="fas fa-utensils"></i>
                {!collapsed && <span>Menu</span>}
              </NavLink>
            </li>
          )}
          {/* {isAdmin && (
            <li>
              <NavLink to="/logs" title="Logs">
                <i className="fas fa-cog"></i>
                {!collapsed && <span>logs</span>}
              </NavLink>
            </li>
          )} */}
        </ul>
      </nav>
    </aside>
  );
}
